// extracted by mini-css-extract-plugin
export default {"item":"Item_item__vIj4W","title":"Item_title__-iwwR","content":"Item_content__YsRbX"};